import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Franchise from './pages/Franchise';
import GlobalExpansion from './pages/GlobalExpansion';
import MyOrders from './pages/MyOrders';
import About from './pages/About';
import Careers from './pages/Careers';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/toaster';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import CartDrawer from './components/CartDrawer';
import Tilt3D from './components/Tilt3D';

function ScrollTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <CartDrawer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST (synchronously during render) to avoid race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
      <Route path="/menu" element={<SiteLayout><Menu /></SiteLayout>} />
      <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
      <Route path="/careers" element={<SiteLayout><Careers /></SiteLayout>} />
      <Route path="/franchise" element={<SiteLayout><Franchise /></SiteLayout>} />
      <Route path="/global-expansion" element={<SiteLayout><GlobalExpansion /></SiteLayout>} />
      <Route path="/account/orders" element={<SiteLayout><MyOrders /></SiteLayout>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-background text-foreground">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollTop />
            <Tilt3D />
            <AppRouter />
            <Toaster />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
